import React from "react";
import "./ResponsiveTable.css"; // Import custom CSS for further customization if needed

const ResponsiveTable = ({ data }) => {
  return (
    <div className="container mt-5">
      <table className="table table-bordered table-striped">
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td style={{ width: "fit-content" }}>{index + 1}</td>
              <td>{item.key}</td>
              <td>{item.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ResponsiveTable;
